<template>
<div class="chapter">
<div class="inner_page">
<section>
<p class="fm-title1">AUTHOR’S NOTE</p>
<p class="fm">I chose hope as the theme for this book because, quite simply, without hope there is nothing.</p>
<p class="fm">Hope floats, it rises, it grows wild in the most deprived soil and it can be the very difference between life and death.</p>
<p class="fm">We have all heard stories of humans enduring the unthinkable and surviving – no, <i>thriving</i>. Listen to what they say and you will find hope in every chapter.</p>
<p class="fm">Hope exists when nothing else can and it is an invisible yet powerful force we can all harness from day to day. I watch people with avid fascination. I read their tales of endurance and struggle and I consume the hope they readily drip from every word. You will find all of that hard-won inspiration on these pages, to remind you of what you already know to be true … you simply must have hope. It is the light. It is the key. It is the fuel. And when you cannot find yours, you can happily borrow mine.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm2.vue?4a729b45